
export class LoopDetector {
	prevItems: string[] = []
	lastItemTime: number = 0
	detectOnMatches: number = 50
	eraseAfterMs: number = 1000

	push(item: string) {
		const now = Date.now()
		if(now > (this.lastItemTime + this.eraseAfterMs)) {
			this.prevItems = []
		}
		this.lastItemTime = now
		this.prevItems.push(item)
		// inefficient but simple
		if(this.prevItems.filter(x => x === item).length >= this.detectOnMatches) {
			return true
		}
		return false
	}
}
